<template>
  <div>
    <div class="attribute-item-row-sub my-3 d-flex">
      <div
        v-for="attribute in subRequestDisplayItems"
        :key="attribute.key"
        class="attribute-item pa-1"
      >
        <div class="attribute-item-title">
          {{ attribute.displayName }}
        </div>
        <div class="attribute-item-value">
          {{ attribute.formatter? attribute.formatter(requestInfo[attribute.key]):requestInfo[attribute.key] }}
        </div>
      </div>
    </div>

    <div v-if="requestType">
      <v-form
        v-if="requestInfo.mainRequest"
        ref="requestFormRef"
      >
        <template v-if="!requestInfo.requestApplicant.relatedFirmId">
          <!-- request applicant -->
          <request-applicant
            v-if="requestType.showDefaultRequestApplicantSection && !isInternal"
            :form-model="requestInfo"
            :is-new-mode="isNewMode"
            :is-view-mode="isViewMode"
            :is-edit-mode="isEditMode"
            :request-type="requestType"
          ></request-applicant>
          <!-- request applicant -->

          <sub-request-applicant-only-name
            v-if="requestType.showOnlyNameRequestApplicantSection || isInternal"
            :form-model="requestInfo"
            :is-new-mode="isNewMode"
            :is-view-mode="isViewMode"
            :is-edit-mode="isEditMode"
          ></sub-request-applicant-only-name>
        </template>
        <template v-else>
          <organization-sub-request-applicant
            v-if="requestType.showDefaultRequestApplicantSection && !isInternal"
            :form-model="requestInfo"
            :is-new-mode="isNewMode"
            :is-view-mode="isViewMode"
            :is-edit-mode="isEditMode"
            :request-type="requestType"
          ></organization-sub-request-applicant>
          <organization-sub-request-applicant-only-name
            v-if="requestType.showOnlyNameRequestApplicantSection || isInternal"
            :form-model="requestInfo"
            :is-new-mode="isNewMode"
            :is-view-mode="isViewMode"
            :is-edit-mode="isEditMode"
            :request-type="requestType"
          ></organization-sub-request-applicant-only-name>
        </template>

        <!-- Request Data Form -->
        <div v-if="requestType.customComponentName">
          <naj-dynamic-form
            :custom-component-name="requestType.customComponentName"
            :required-data="requestInfo.requestCustomData"
            :form-model="requestInfo"
            :view-mode="isViewMode"
          ></naj-dynamic-form>
        </div>
        <!-- Request Data Form -->

        <div
          v-if="requestType.showRequestReasonSection"
          class="px-3 content-wrapper"
        >
          <h3 class="d-inline-block primary--text font-weight-bold col col-2 mb-4">
            {{ local.bankruptcy.subRequests.requestReasons }}
          </h3>
          <span
            v-if="!isViewMode"
            class="request-reasons-warning"
          >
            <v-icon color="#FAAD14">
              mdi-alert
            </v-icon>
            {{ local.bankruptcy.subRequests.requestReasonsWarning }}
          </span>

          <template v-if="requestInfo.reasons.length > 0">
            <naj-box
              v-for="(requestReason,index) in requestInfo.reasons"
              :key="index"
              :title="local.bankruptcy.subRequests.reasonText[index]"
            >
              <v-row>
                <v-col cols="6">
                  <span>
                    <label class="request-reason-label"> {{ local.bankruptcy.subRequests.reason }}</label>
                    <div>
                      <span class="request-reason-text">
                        {{ requestReason.reasonText }}
                      </span>
                    </div>
                  </span>
                </v-col>

                <v-col
                  class="text-center"
                  cols="4"
                >
                  <template v-if="requestType.showRequestReasonAttachment">
                    <label class="request-reason-label">{{ local.bankruptcy.subRequests.attachment }} </label>
                    <div class="row justify-content-center h-75">
                      <div class="align-items-center file-name h-75">
                        <div
                          v-if="requestReason.fileName"
                          class="col-sm-12"
                        >
                          {{ requestReason.fileName }}
                        </div>
                        <div class="col-sm-12">
                          <v-btn
                            v-if="requestReason.fileId && requestReason.fileName"
                            icon
                            @click="handleViewAttachment(requestReason)"
                          >
                            <v-icon>
                              mdi-eye
                            </v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </div>
                  </template>
                </v-col>
              </v-row>
            </naj-box>
          </template>
        </div>
        <div
          v-if="requestType.showAttachmentSection"
          class="px-3 content-wrapper"
        >
          <h3 class="d-inline-block primary--text font-weight-bold col col-2 mb-4">
            {{ local.attachments.title }}
          </h3>
          <template v-if="requestInfo.attachments.length > 0">
            <naj-box
              v-for="(file,index) in requestInfo.attachments"
              :key="index"
              :title="file.fileName"
            >
              <v-row>
                <v-col cols="10">
                  <label class="request-reason-label"> {{ local.bankruptcy.subRequests.attachmentName }}</label>
                  <div>
                    <span class="request-reason-text">
                      {{ file.fileName }}
                    </span>
                  </div>
                </v-col>

                <v-col
                  class="d-flex justify-content-end align-items-center"
                  cols="2"
                >
                  <v-btn
                    icon
                    @click="handleViewAttachment(file)"
                  >
                    <v-icon>
                      mdi-eye
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </naj-box>
          </template>
        </div>
      </v-form>
    </div>

    <render-attachment-modal
      :attachment-file="selectedFile"
      :modal-visibility="showViewAttachmentModal"
      @modalClose="hideViewAttachmentModal"
    >
    </render-attachment-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { toHijriDate } from '@/helpers/utils';
import RequestApplicant from './sub-request-applicant.vue';
import RenderAttachmentModal from '@/components/shared/attachment-modal/render-attachment-modal';
import { fileType } from '@/modules/bankruptcy/helpers/enum';
import subRequestApplicantOnlyName from '@/modules/bankruptcy/components/sub-requests/sub-request-applicant-only-name.vue';
import { mode } from '@/helpers/enum';
const { mapActions: mapBankruptcyActions, mapState: mapBankruptcyState } = createNamespacedHelpers('BankruptcyModule');
import OrganizationSubRequestApplicant from './organization-sub-request-applicant.vue';
import OrganizationSubRequestApplicantOnlyName from './organization-sub-request-applicant-only-name.vue';

export default {
  name: 'RequestSummary',
  components: {
    RequestApplicant,
    RenderAttachmentModal,
    subRequestApplicantOnlyName,
    OrganizationSubRequestApplicant,
    OrganizationSubRequestApplicantOnlyName,
  },
  props: {
    requestInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      toHijriDate,
      mode,
      requestType: null,
      showViewAttachmentModal: false,
      selectedFile: {},
    };
  },
  computed: {
    ...mapBankruptcyState([
      'attachmentTypes',
    ]),
    // requestType() {
    //   return this.RequestTypes[this.$route.params.requestType] || {};
    // },
    isViewMode() {
      return this.requestInfo && this.requestInfo.mode === mode.view;
    },
    isEditMode() {
      return this.requestInfo && this.requestInfo.mode === mode.update;
    },
    isNewMode() {
      return this.$route.params.subRequestObjectKey === null || this.$route.params.subRequestObjectKey === undefined;
    },
    isInternal() {
      return this.$route.meta.isInternal || this.$route.query.isInternal == 'true' || this.requestInfo.isInternal;
    },
    mainRequestHeaders() {
      return [
        {
          key: 'requestCategoryName',
          displayName: this.local.bankruptcy.bankruptcyFile.requestCategoryName,
        },
        {
          key: 'legalCapacityName',
          displayName: this.local.bankruptcy.bankruptcyFile.legalCapacityName,
        },
        {
          key: 'requestOwnerTypeName',
          displayName: this.local.bankruptcy.bankruptcyFile.onBehalfOf,
        },
        {
          key: 'courtName',
          displayName: this.local.bankruptcy.bankruptcyFile.courtName,
        },
        {
          key: 'openedProcedureName',
          displayName: this.local.bankruptcy.bankruptcyFile.openedProcedureName,
        },
        {
          key: 'openedProcedureDate',
          displayName: this.local.bankruptcy.bankruptcyFile.openedProcedureDate,
          formatter: toHijriDate,
        },

      ];
    },
    subRequestHeaders() {
      return [
        {
          key: 'requestTypeName',
          displayName: this.local.bankruptcy.home.headers.subRequestTypeName,
        },
        {
          key: 'subRequestCode',
          displayName: this.local.bankruptcy.home.headers.subRequestCode,
        },
        {
          key: 'requestDate',
          displayName: this.local.bankruptcy.home.headers.requestDate,
          formatter: toHijriDate,
        },
        {
          key: 'requestStatusName',
          displayName: this.local.bankruptcy.home.headers.requestStatusName,
        },

      ];
    },
    mainRequestDisplayItems() {
      return this.mainRequestHeaders.map((prop) => {
        prop.value = this.requestInfo.mainRequest[prop.key];
        return prop;
      }).filter(item => item.value);
    },
    subRequestDisplayItems() {
      return this.subRequestHeaders.map((prop) => {
        prop.value = this.requestInfo[prop.key];
        return prop;
      }).filter(item => item.value);
    },
  },
  watch: {},
  created() {
    this.getSubRequestType(this.$route.params.requestType)
      .then((data) => {
        this.requestType = data.data;
      });
  },
  mounted() {
    this.getAttachmentTypes();
  },
  methods: {
    ...mapBankruptcyActions([
      'getAttachmentTypes', 'getSubRequestType',
    ]),
    handleViewAttachment(file) {
      this.$set(this, 'selectedFile', {
        name: file.fileName,
        isImage: file.fileTypeId == fileType.img,
        sharePointId: file.fileId,
      });
      this.showViewAttachmentModal = true;
    },
    hideViewAttachmentModal() {
      this.showViewAttachmentModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.attribute-item-row {
  display: flex;
  justify-content: space-between;
  position: relative;
  border: 1px solid #dbdbdb;
}

.attribute-item-row-sub {
  display: flex;
  border: 1px solid #dbdbdb;
  justify-content: space-evenly;
}
.attribute-item {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 0 10px 0 10px;
}

.attribute-item-title {
  font-size: 14px;
  font-weight: bold;
  color: #158e8d;
}

.attribute-item-value {
  font-weight: bolder;
  font-size: 16px;
  color: #02363d;
}

.request-reasons-warning {
  font-size: 16px;
  color: #faad14;
}

.request-reason-label {
  font-size: 20px;
}
.request-reason-text {
  font-size: 15px;
  color: #484952a0;
}
.content-wrapper {
  border: 1px solid #e4e5e6 !important;
  margin-bottom: 25px;
}

.file-name {
  font-size: 18px;
}

::v-deep {
  .request-info-root {
    background-color: #faf9f4;
    padding: 10px 20px;
    border-radius: 5px;
    border: 1px solid #158e8d;
    margin-bottom: 20px;

    > div {
      min-width: 170px;
      > b {
        display: flex;
        width: 100%;
        justify-content: space-between;
        font-weight: 700;
        margin-bottom: 5px;
        > span {
          margin-right: 0;
          margin-left: 5px;
        }
      }
    }
  }
}
</style>
